import React, { Component } from "react";
import './../css/seia.css';
import socketIOClient from "socket.io-client";
import { httpUploadFile, URLS, httpRequest } from "./../network";
import download from "downloadjs";
import { SCRAPING_PAGE_TYPE, isNullOrEmpty, toObject } from "./../utils";

class Seia extends Component {

    constructor() {
        super();

        this.ViewState = {
            Pertinencia: 1,
            Adendas: 2,
            RepresentativePoint: 3,
            PertenenciaEstado: 4
        };

        this.state = {
            rows: [],
            adendaRows: [],
            representativeRows: [],
            file: null,
            socket: null,
            filePath: "",
            fileName: "",
            currentRow: "0",
            maxRows: "0",
            showLoader: false,
            currentView: this.ViewState.Pertinencia
        }

        
    }

    componentDidMount() {
        this.fileSelector = this.buildFileSelector();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }
    
    buildFileSelector = () => {
		
        const fileSelector = document.createElement("input");
        fileSelector.setAttribute("type", "file");
        fileSelector.setAttribute("multiple", "multiple");
    
        fileSelector.onchange = this.parseFile();
        return fileSelector;
    };

    parseFile = () => (e) => {

        const file = e.target.files[0];   
        httpUploadFile(URLS.UPLOAD_FILE, { newFile: file})
            .then ( (data) => {
                
                this.setState({filePath: data.path, fileName: data.realname });
            })
            .catch ((err) => {
                console.log ("err: ", err);
            });
    };
        
    onFileClickSelect = () => (e) => {
        e.preventDefault();
        this.fileSelector.click();
    };

    _getDataForView(currentView) {

        let info = {
            fileExportName: "",
            rows: []
        };

        switch(currentView) {
            case this.ViewState.Pertinencia:
                case this.ViewState.PertenenciaEstado:

                info.fileExportName = "pertinencias_procesados.xlsx";
                info.rows = this.state.rows;
                break;
            case this.ViewState.Adendas:

                info.fileExportName = "adendas_procesadas.xlsx";
                info.rows = this.state.adendaRows;
                break;
            case this.ViewState.RepresentativePoint:

                info.fileExportName = "punto_representativo_procesadas.xlsx";
                info.rows = this.state.representativeRows;
                break;
        }

        return info
    }


    downloadFileResult (filename) {

        const infoData = this._getDataForView(this.state.currentView);
        const fileResultName = infoData.fileExportName;
        fetch(URLS.DOWNLOAD_FILE + "?file="+filename)
            .then ((res) => {
                return res.blob();
            })
            .then ( (blob) => {
                download(blob, fileResultName, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            })
            .catch( (err) => {
                this.props.errorMessage("Error descargando el archivo: " + JSON.stringify(err));
            });
    }

    onProcessBackgroundClick = () => {

        this.setState({rows: [], representativeRows: [], adendaRows: [], showLoader: false, currentRow: 0, maxRows: 0});
        const params = { 
            path: this.state.filePath, 
            task: this.state.currentView
        };

        httpRequest(URLS.SEIA_BACKGROUND, params, "POST")
            .then ((resp) => {

                if (!resp.success) {
                    this.props.errorMessage(resp.message);
                    return;
                }

                this.props.errorMessage("El archivo sera procesado en el servidor. \nCuando este listo podras revisarlo en la pestaña de \"Trabajos en Background\" ");
            })
            .catch ((err) => {
                this.props.errorMessage(err);
            });
    }

    onProcessClick = () => {

        const socket = socketIOClient(URLS.MAIN_URL, {  query: "type="+ SCRAPING_PAGE_TYPE.Seia});
        socket.on("connection", (data) => {
            console.log (data)            
        });

        socket.on("on_row_incoming", (data) => {
            
            const payload = toObject(data);
            if (!payload || !payload.tender) {
                return;
            }

            const infoData = this._getDataForView(this.state.currentView);

            let currentrows = infoData.rows;
            currentrows.push(payload.tender);
            if (this.state.currentView === this.ViewState.Pertinencia || this.state.currentView === this.ViewState.PertenenciaEstado) {
                this.setState({ rows: currentrows, currentRow: payload.row, currentRevision: "Revisando Rol " + payload.tender.rol});
            }
            else if (this.state.currentView === this.ViewState.Adendas) {
                this.setState({ adendaRows: currentrows, currentRevision: "Revisando  " + payload.tender.name});
            }
            else {
                this.setState({ representativeRows: currentrows, currentRow: payload.row, currentRevision: "Revisando  " + payload.tender.name});
            }
        });

        socket.on("on_error", (errObj) => {

            this.setState({showLoader: false, maxRows: "", currentRow: 0});

            const err = errObj.err;
            this.props.errorMessage(err.message);
            socket.emit("disconnect");
            socket.disconnect();

            if ( !isNullOrEmpty(errObj.file)) {
                this.downloadFileResult(errObj.file);
            }
        });

        socket.on ("on_process_end", (filename) => {
            
            socket.emit("disconnect");
            socket.disconnect();

            this.setState({showLoader: false});
            this.downloadFileResult(filename);          
        });

        socket.on("on_rows_to_proccess", (rowsNumber) => {
            this.setState({maxRows: rowsNumber});
        })

        this.setState({rows: [], representativeRows: [], adendaRows: [], showLoader: true, currentRow: 0, maxRows: 0});
        const params = { 
            path: this.state.filePath, 
            task: this.state.currentView
        };

        socket.emit("process_start", params);
    }

    scrollToBottom = () => {

        if (isNullOrEmpty(this.messagesEnd)) {
            return;
        }

        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    
    onTabClick = (choice) => (e) =>  {
        this.setState({currentView: choice, fileName: "", maxRows: 0});
    }

    _renderPertView = () => {

        return (
            <div className="seia-inner-container">
                <h3>SEIA - Pertinencias</h3>
                <p>Búsqueda de pertinencias</p>

                <fieldset className="scheduler-border" >
                    <legend className="scheduler-border">Selecciona el archivo</legend>
                    <div className="filter-doc-file">
                        <input type="text" id="filterIdsTxt" className="form-control"
                            placeholder="Selecciona archivo" value={this.state.fileName}/>
                        <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}>Abrir</button>
                    </div>
                </fieldset>
                <div className="seia-progress-container">
                    <label>Resultado</label>
                    <div className="progress-state">
                        { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                        <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                    </div>
                </div>

                <div id="tableContainer" className="result-table">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Supervisor</th>
                                <th scope="col">Encargado</th>
                                <th scope="col">Latitud</th>
                                <th scope="col">Longitud</th>
                                <th scope="col">Descripcción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.rows.map( (row, index) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{row.id}</th>
                                            <td>{row.supervisor}</td>
                                            <td>{row.owner}</td>
                                            <td>{row.lat}</td>
                                            <td>{row.lng}</td>
                                            <td>{row.description}</td>
                                        </tr>
                                    );
                                })   
                            }
                        
                        </tbody>
                    </table>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
                <div className="btn-container">
                    <button className="btn btn-outline-primary" onClick={this.onProcessClick}>Procesar</button>
                </div>
            </div>
        );
    }

    _rederAdendaView = () => {

        return(
            <div className="seia-inner-container">
               
               <h3>SEIA - Búsqueda de Adendas</h3>
                <p>
                    Se trata de identificar la cantidad de adendas dentro de un proyecto. Archivo de ejemplo.
                    <a href={URLS.MAIN_URL + "assets/adendas_ejemplo.xlsx"}>
                        <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                    </a>
                </p>
               
                <fieldset className="scheduler-border" >
                    <legend className="scheduler-border">Selecciona el archivo</legend>
                    <div className="filter-doc-file">
                        <input type="text" id="filterIdsTxt" className="form-control"
                            placeholder="Selecciona archivo" value={this.state.fileName}/>
                        <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}>Abrir</button>
                    </div>
                </fieldset>

                <div className="seia-progress-container">
                    <label>Resultado</label>
                    <div className="progress-state">
                        { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                        <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                    </div>
                </div>

                <div id="tableContainer" className="result-table">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Folio</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">URL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.adendaRows.map( (row, index) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{row.name}</th>
                                            <td>{row.folio}</td>
                                            <td>{row.date}</td>
                                            <td><a href={row.url} target="_blank" rel="noopener noreferrer">{row.url}</a></td>
                                        </tr>
                                    );
                                })   
                            }
                        
                        </tbody>
                    </table>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
                

                <div className="btn-container">
                    <button className="btn btn-outline-primary" onClick={this.onProcessClick}>Procesar</button>
                    <button className="btn btn-outline-primary" onClick={this.onProcessBackgroundClick}>Proceso Background</button>
                </div>
            </div>
        );
    }

    _rederRepresentativePoint = () => {

        return(
            <div className="seia-inner-container">
               
               <h3>SEIA - Búsqueda del Punto Representativo</h3>
                <p>
                    Se trata de identificar los puntos representativo en cada <b>Estudio de impacto ambiental</b>. Archivo de ejemplo.
                    <a href={URLS.MAIN_URL + "assets/seia_punto_ejemplo.xlsx"}>
                        <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                    </a>
                </p>
               
                <fieldset className="scheduler-border" >
                    <legend className="scheduler-border">Selecciona el archivo</legend>
                    <div className="filter-doc-file">
                        <input type="text" id="filterIdsTxt" className="form-control"
                            placeholder="Selecciona archivo" value={this.state.fileName}/>
                        <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}>Abrir</button>
                    </div>
                </fieldset>

                <div className="seia-progress-container">
                    <label>Resultado</label>
                    <div className="progress-state">
                        { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                        <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                    </div>
                </div>

                <div id="tableContainer" className="result-table">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">URL</th>
                                <th scope="col">Puntos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.representativeRows.map( (row, index) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{row.name}</th>
                                            <td><a href={row.url} target="_blank" rel="noopener noreferrer">{row.url}</a></td>
                                            <td>
                                                { row.points.map( (point, index) => {
                                                    return <div key={index}>X: {point.x} Y: {point.y} </div>
                                                }) }
                                            </td>
                                        </tr>
                                    );
                                })   
                            }
                        
                        </tbody>
                    </table>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
                

                <div className="btn-container">
                    <button className="btn btn-outline-primary" onClick={this.onProcessClick}>Procesar</button>
                    <button className="btn btn-outline-primary" onClick={this.onProcessBackgroundClick}>Proceso Background</button>
                </div>
            </div>
        );
    }

    _pertenenciastateView() {

        return (
            <div className="seia-inner-container">
                <h3>SEIA - Estado Pertinencias</h3>
                <p>
                    Valida el estado de la pertenencia. Archivo de ejemplo.
                    <a href={URLS.MAIN_URL + "assets/seia_pert_state_ejemplo.xlsx"}>
                        <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                    </a>
                </p>

                <fieldset className="scheduler-border" >
                    <legend className="scheduler-border">Selecciona el archivo</legend>
                    <div className="filter-doc-file">
                        <input type="text" id="filterIdsTxt" className="form-control"
                            placeholder="Selecciona archivo" value={this.state.fileName}/>
                        <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}>Abrir</button>
                    </div>
                </fieldset>
                <div className="seia-progress-container">
                    <label>Resultado</label>
                    <div className="progress-state">
                        { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                        <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                    </div>
                </div>

                <div id="tableContainer" className="result-table">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Estado Actual</th>
                                <th scope="col">Nuevo Estado</th>
                                <th scope="col">URL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.rows.map( (row, index) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{row.id}</th>
                                            <td>{row.currentState}</td>
                                            <td>{row.nState}</td>
                                            <td><a href={row.url} target="_blank" rel="noopener noreferrer">{row.url}</a></td>
                                        </tr>
                                    );
                                })   
                            }
                        
                        </tbody>
                    </table>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
                <div className="btn-container">
                    <button className="btn btn-outline-primary" onClick={this.onProcessClick}>Procesar</button>
                </div>
            </div>
        );
    }

    _displayView () {

        switch(this.state.currentView) {
            case this.ViewState.Pertinencia:
                return this._renderPertView();
            case this.ViewState.Adendas:
                return this._rederAdendaView();
            case this.ViewState.RepresentativePoint:
                return this._rederRepresentativePoint();
            case this.ViewState.PertenenciaEstado:
                return this._pertenenciastateView();
        }
    }

    render () {
        return (
            <div className="seia-container">
                <div className="sii-tab-container">
                    <input type="radio" id="tab-1" name="show" onClick={this.onTabClick(1)} />
                    <input type="radio" id="tab-2" name="show" onClick={this.onTabClick(2)} />
                    <input type="radio" id="tab-3" name="show" onClick={this.onTabClick(3)} />
                    <input type="radio" id="tab-4" name="show" onClick={this.onTabClick(4)} />
                    <div className="sii-tab">
                        <label htmlFor="tab-1">Pertinencias</label>
                        <label htmlFor="tab-2">Adendas</label>
                        <label htmlFor="tab-3">Punto Representativo</label>
                        <label htmlFor="tab-4">Estado Pertinencias</label>
                    </div>
                </div>
                { this._displayView() }
            </div>
        );
    }
    
}

export default Seia;